import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PaymentSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate('/dashboard');
    }, 5000);
  }, [navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>✓</div>
        <h1 style={styles.title}>Payment Successful!</h1>
        <p style={styles.text}>
          Thank you for your membership payment. You are now entered into the monthly draw.
        </p>
        <p style={styles.subtext}>
          You will be redirected to your dashboard in 5 seconds...
        </p>
        <button style={styles.button} onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f0f4f8'
  },
  card: {
    backgroundColor: 'white',
    padding: '48px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '480px',
    textAlign: 'center'
  },
  icon: {
    width: '64px',
    height: '64px',
    backgroundColor: '#c6f6d5',
    color: '#276749',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    fontWeight: '700',
    margin: '0 auto 24px'
  },
  title: {
    color: '#3e5859',
    marginBottom: '16px',
    fontSize: '28px'
  },
  text: {
    color: '#4a5568',
    fontSize: '16px',
    lineHeight: '1.6',
    marginBottom: '12px'
  },
  subtext: {
    color: '#718096',
    fontSize: '14px',
    marginBottom: '24px'
  },
  button: {
    backgroundColor: '#3e5859',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '12px 24px',
    fontSize: '16px',
    cursor: 'pointer'
  }
};